import React, { useCallback, useEffect, useState } from 'react';
import useCountDown from 'react-countdown-hook';
import { useDispatch, useSelector } from 'react-redux';
import useSound from 'use-sound';

import ringTone from '../../../../../sounds/panther-ring.mp3';
import { playSound, registerSound, unregisterSound } from '../../../base/sounds';
import { BEEP_TONE_SOUND_ID } from '../../constants';


const initialTime = 60 * 1000; // initial time in milliseconds, defaults to 60000
const interval = 1000;
const OutGoingRingTone = () => {
    const dispatch = useDispatch();
    const { room } = useSelector(state => state['features/base/conference']);
    const [ play, { stop } ] = useSound(ringTone);

    const [ timeLeft, { start, pause, resume, reset } ] = useCountDown(initialTime, interval);

    // useEffect(() => {
    //     console.log('mounting----------------------');
    //     play();

    //     return () => {
    //         stop();
    //     };
    // }, []);
    useEffect(() => {
        start();
    }, []);
    useEffect(() => {
        const shouldRinging = sessionStorage.getItem(`ringing-${room}`);

        if (timeLeft>0 && shouldRinging) {
            dispatch(playSound(BEEP_TONE_SOUND_ID));
        }
    }, [ timeLeft ]);

    return (
        <>

        </>
    );


};

export default OutGoingRingTone;
